/**
 * Feature flags — single source of truth on the frontend.
 *
 * Use sparingly. When a flag is no longer needed, delete it entirely
 * (don't leave dead `if (FLAG)` branches lying around).
 */

/**
 * Premium subscriptions / paid features are in maintenance.
 * When true:
 *  • The /pricing page shows a maintenance banner and disables the CTA.
 *  • Upgrade CTAs across the app are hidden.
 *  • Premium-only feature buttons (price alerts, CSV export) are hidden.
 *  • Stripe checkout endpoint is not called (frontend short-circuits).
 *
 * Flip to `false` to re-open subscriptions.
 */
export const PREMIUM_MAINTENANCE = true;
